import React from 'react';
import { Link } from 'react-router-dom';

export const FooterStatesBar = ({ states }) => (
  <div className="border-b border-white/10">
    <div className="container mx-auto px-6 py-10">
      <h3 className="text-white font-semibold mb-2 text-lg">States We Buy Houses In</h3>
      <p className="text-sm text-slate-400 mb-5">Statewide cash buyers — see all cities in each state.</p>
      <div className="flex flex-wrap gap-2">
        {states.map((s) => (
          <Link
            key={s.slug}
            to={`/we-buy-houses/${s.slug}`}
            data-testid={`footer-state-${s.slug}`}
            className="text-sm font-semibold text-white px-4 py-2 bg-emerald-600 hover:bg-emerald-700 rounded-full transition-colors"
          >
            We Buy Houses {s.name}
          </Link>
        ))}
      </div>
    </div>
  </div>
);

export const FooterCitiesBar = ({ cities }) => (
  <div className="border-b border-white/10">
    <div className="container mx-auto px-6 py-12">
      <h3 className="text-white font-semibold mb-2 text-lg">Cities We Buy Houses In</h3>
      <p className="text-sm text-slate-400 mb-5">Fast cash offers and off-market wholesale deals across America's top markets.</p>
      <div className="flex flex-wrap gap-2">
        {cities.map((c) => (
          <Link
            key={c.slug}
            to={`/we-buy-houses/${c.slug}`}
            data-testid={`footer-city-${c.slug}`}
            className="text-sm text-slate-300 hover:text-emerald-400 px-3 py-1.5 bg-white/5 hover:bg-white/10 rounded-full transition-colors"
          >
            We Buy Houses {c.name}, {c.stateAbbr}
          </Link>
        ))}
      </div>
    </div>
  </div>
);
